import moment from 'moment';

export default function validHours(value: string) {
    const valid = moment(value, "hh:mm")
    if (valid.isValid()) {
        return true;
    }
    return false;
}
